import { createAction, props } from '@ngrx/store';

import { INote } from '../model';

const AI_UMC_FEATURE_KEY = `[AI-UMC Release Note]`;

export const loadAIUMCReleaseNotes = createAction(
  `${AI_UMC_FEATURE_KEY} Load`,
  props<{ nodeId: string; sectionId: string }>()
);

export const loadAIUMCReleaseNotesStart = createAction(
  `${AI_UMC_FEATURE_KEY} Loading`
);

export const loadAIUMCReleaseNotesFailed = createAction(
  `${AI_UMC_FEATURE_KEY} Load Failed`
);

export const loadAIUMCReleaseNotesCompleted = createAction(
  `${AI_UMC_FEATURE_KEY} Load Complete`,
  props<{ notes: INote[] }>()
);

export const selectReleaseNote = createAction(
  `${AI_UMC_FEATURE_KEY} Set Selected UMC Release Notes By User`,
  props<{ note: INote | null }>()
);

export const createReleaseNote = createAction(
  `${AI_UMC_FEATURE_KEY} Trigger Create UMC Release Note`,
  props<{ isCreating: boolean }>()
);

export const resetAIUMCReleaseNoteState = createAction(
  `${AI_UMC_FEATURE_KEY} Reset State`,
  props<{ notes: INote[]; note: INote | null; isCreating: boolean }>()
);

export const setTriggerSaveApiInDoc = createAction(
  `${AI_UMC_FEATURE_KEY} Trigger Save API In Document`,
  props<{
    triggerSaveApiInDoc: boolean;
    payloadForUMCPostDocSave?: { nodeId: string; sectionId: string } | null;
  }>()
);

export const setProcessingStateOnUMCAPI = createAction(
  `${AI_UMC_FEATURE_KEY} Set Processing State On UMC API`
);
export const setCurrentSelectedAIUMCNotes = createAction(
  `${AI_UMC_FEATURE_KEY} Set Current Selected AI UMC Notes`,
  props<{ currentSelectedAIUMCNotes: INote[] }>()
);

export const removeAIUMCReleaseNote = createAction(
  `${AI_UMC_FEATURE_KEY} Remove Single Note`,
  props<{ notes: INote[] }>()
);
